// ============================================================================
// KOREAN TRANSLATIONS - CHAPTER 8: 지극히 높으신 분의 도움 (보너스)
// ============================================================================
// 레벨 92 (1개의 보너스 레벨, 3개의 질문)

export const chapter8Translations = {
  name: "지극히 높으신 분의 도움",
  description: "지극히 높으신 분의 은밀한 곳에 거주하며 전능하신 분의 그늘 아래에 사는 자",
  
  spiritualWisdom: {
    principle: "당신은 산 정상에 도달했고, 지식이 획득되었습니다",
    scripture: "지극히 높으신 분의 은밀한 곳에 거주하며 전능하신 분의 그늘 아래에 사는 자 (시편 91:1)",
    application: "흔들리지 않는 믿음은 삶의 경험, 자비, 그리고 예수님의 진정한 사랑이 필요합니다. 시련은 당신의 마음, 선택한 진정한 길을 시험할 것입니다."
  },
  
  levels: {
    92: {
      name: "지극히 높으신 분의 은밀한 곳",
      challenge: "당신은 산 정상에 있습니다... 하지만 흔들리지 않는 믿음은 지금 시작됩니다...",
      easy: {
        question: "예수님은 당신에게 개인적으로 누구이십니까?",
        options: [
          "단순한 예언자",
          "나의 개인적인 주님이자 구세주",
          "전설",
          "철학자"
        ],
        hint: "우리를 구원하기 위해 생명을 바치시는 분",
        funFact: "✝️ 예수님은 하나님이십니다! 그분은 단순한 역사적 인물이 아닙니다 - 그분은 살아 계시며 우리 각자와 개인적인 관계를 원하십니다!"
      },
      medium: {
        question: "왜 다니엘처럼 금식하는 것이 하나님을 더 잘 듣게 해줍니까?",
        options: [
          "체중 감량을 위해",
          "우리가 사랑하는 것을 박탈하고 변화된 마음을 갖기 위해",
          "다른 사람들에게 깊은 인상을 주기 위해",
          "더 강해지기 위해"
        ],
        hint: "가장 사랑하는 것을, 고요함과 지혜 속에서 자신에게서 박탈하세요",
        funFact: "🙏 영적 금식은 우리의 마음을 깊은 변화 - 종종 고통스러운 - 를 위해 준비시키며 하나님께 더 가까이 다가가게 합니다!"
      },
      hard: {
        question: "획득한 이 모든 지식에 대한 마음의 진정한 응답은 무엇입니까?",
        options: [
          "나는 이제 완벽합니다",
          "예수님, 제 마음을 드리며 세례받기를 원합니다",
          "나는 다른 사람들보다 더 잘 압니다",
          "더 이상 도움이 필요 없습니다"
        ],
        hint: "진정한 믿음은 완전한 항복과 예수님께 대한 헌신으로 이어집니다",
        funFact: "🌟✨ 당신은 산 정상에 도달했고, 지식이 획득되었습니다 ✨\n\n💖 흔들리지 않는 믿음은 삶의 경험, 자비, 그리고 예수님의 진정한 사랑이 필요합니다 💖\n\n🔥 삶의 다양한 시련은 당신의 길, 우리가 선택하는 진정한 길, 우리의 마음을 시험할 것입니다 🔥\n\n😔 우리는 불완전한 채로 남아 있고, 우리의 욕망은 많으며, 이익이나 개인적 안락에 대한 사랑이 너무 자주 우리의 이기적인 우선순위가 됩니다 😔\n\n🙏 하나님께 지혜, 그분의 사랑, 그분의 힘을 구하고, 겸손하게 자신의 약점을 인정하세요. 왜냐하면 우리는 그분으로부터 아무것도 숨길 수 없기 때문입니다... 아무것도 🙏\n\n🥖 다니엘처럼 금식하세요: 가장 사랑하는 것을, 고요함과 지혜 속에서, 잠시 동안 자신에게서 박탈하세요 🥖\n\n💫 이것은 당신이 하나님을 더 잘 듣고, 깊은 변화를 위해 준비된 마음의 상태를 갖게 해줄 것입니다 💫\n\n🌙 그러면 요셉처럼 꿈과 환상이 더 명확해질 것입니다 🌙\n\n⚠️ 교만을 조심하세요: '나는 항상 옳다' 또는 '나는 더 잘 안다'에 굴복하지 마세요 ⚠️\n\n🎁 왜냐하면 하나님의 계시는 특별한 은혜이기 때문입니다 🎁\n\n💝 믿음을 갖는 것은 관계와 마음의 자유로운 길로 들어가는 것입니다 💝\n\n🦸‍♂️ 그것은 당신을 강력한 영웅으로 만들어, 불가능한 것을 할 수 있게 할 것입니다 🦸‍♂️\n\n✝️ 지식의 정상에서, 진실한 마음은 말합니다: '예수님, 제 마음을 드리며 세례받기를 원합니다' ✝️\n\n🏔️ 당신은 산 정상에 도달했습니다, 굳게 붙잡고, 인내하세요! 🏔️\n\n⬇️ 내려가서 이 귀중한 보물을 운반해야 합니다: 영생의 희망 ⬇️\n\n🏆✨ 브라보! 우리는 당신을 자랑스럽게 생각합니다 ✨🏆\n🌟 용기 용감한 평화의 전달자 🌟\n🕊️✨ 하나님이 당신을 축복하시기를 ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
